import type { Intl } from '@/intl'

export function formatPaymentDueDate(intl: Intl, dueDate: string) {
  const date = new Date(dueDate.includes('T') ? dueDate : `${dueDate}T00:00:00`)
  const today = new Date()
  const isToday
    = date.getFullYear() === today.getFullYear()
      && date.getMonth() === today.getMonth()
      && date.getDate() === today.getDate()

  if (isToday) {
    return intl.formatRelativeTime(0, 'day', { numeric: 'auto' })
  }

  return intl.formatDate(date, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

export function formatPaymentDueDateLabel(
  intl: Intl,
  dueDate: string,
  translationId = 'payment_scope_remaining_due_date_label',
  defaultMessage = '(pay before {date})',
) {
  if (paymentDueDateIsToday(dueDate)) {
    return `(${intl.formatMessage({
      id: 'payment_scope_deposit_due_today_label',
      defaultMessage: 'Due today',
    })})`
  }

  return intl.formatMessage(
    {
      id: translationId,
      defaultMessage,
    },
    {
      date: formatPaymentDueDate(intl, dueDate),
    },
  )
}

export function paymentDueDateIsToday(dueDate: string) {
  const date = new Date(dueDate.includes('T') ? dueDate : `${dueDate}T00:00:00`)
  const today = new Date()
  return date.getFullYear() === today.getFullYear()
    && date.getMonth() === today.getMonth()
    && date.getDate() === today.getDate()
}
